import Link from 'next/link';
import { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { getAllCategory, getBLogs } from '../../redux/actions/blog';
import MetaSeo from '../MetaSeo';
import useTrans from '../../hooks/useTrans';
import { useRouter } from 'next/router';

export default function Blog(props) {
    const [rows, setRows] = useState(props.rows || []);
    const [total, setTotal] = useState(props.total || 0);
    const [search, setSearch] = useState('');
    const [page, setPage] = useState(1);
    const [category_name, setCategoryName] = useState('');
    const router = useRouter();
    const dispatch = useDispatch();
    const trans = useTrans();
    const submitSearch = async (event) => {
        event.preventDefault();
        const data = await getBLogs({ name: search?.trim(), page: 1, category: category_name }, dispatch);
        setPage(1);
        setTotal(data.total);
        setRows(data.rows);
    };
    const { category } = useSelector(state => {
        return {
            category: state.news.category,
        };
    }, shallowEqual);

    useEffect(() => {
        setRows(props.rows);
        setTotal(props.total);
        setCategoryName('');
        setSearch('');
        setPage(1);
        getAllCategory({}, dispatch);
    }, [dispatch, props]);

    const loadMore = async () => {
        let new_page = parseInt(page) + 1;
        setPage(new_page);
        const data = await getBLogs({ page: new_page, limit: 10, name: search, category: category_name }, dispatch);
        if (data) {
            const new_data = [...rows, ...data.rows];
            setRows(new_data);
        }
    };
    const getPostByCategory = async (name) => {
        const data = await getBLogs({ category: name, name: search?.trim() }, dispatch);
        setCategoryName(name);
        if (data) {
            setRows(data.rows);
            setTotal(data.total);
        }
    };
    const filterTag = async (tag_name) => {
        let new_search = `#${tag_name}`;
        setSearch(new_search);
        const data = await getBLogs({ name: new_search, page: 1 }, dispatch);
        setPage(1);
        setTotal(data.total);
        setRows(data.rows);
    };
    const dataSeo = {
        url: process.env.NEXT_PUBLIC_SEO_URL,
        type: 'website',
        title: "ニュース | TCOM JAPAN",
        description: 'TCOM JAPANの社内活動や業務提携に関する注目のニュースやイベントを記載しています。',
        domain: process.env.NEXT_PUBLIC_DOMAIN,
        card: 'summary_large_image',
    };

    return (
        <>
            <MetaSeo {...dataSeo} />
            <div className='main-content'>
                <div className='r-big-banner'>
                    <div className='r-page-title'>
                        <div className='container'>
                            <h3>BLOG</h3>
                        </div>
                    </div>
                </div>
                <div className='r-top'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-12 col-md-6'>
                                <div className='title-left'>
                                    <h3>BLOG</h3>
                                    {category_name ? <div className='handleBtnClose'>
                                        <Link href='/news'><a >{category_name}</a></Link>
                                    </div> : ''}
                                </div>
                            </div>
                            <div className='col-12 col-md-6'>
                                <div className='search'>
                                    <form>
                                        <input type='text' placeholder='探す' value={search} onChange={(e) => setSearch(e.target.value)} />
                                        <button onClick={submitSearch}>
                                            <svg width={24} height={24} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                                                <path d='M21 21L16.514 16.506L21 21ZM19 10.5C19 12.7543 18.1045 14.9163 16.5104 16.5104C14.9163 18.1045 12.7543 19 10.5 19C8.24566 19 6.08365 18.1045 4.48959 16.5104C2.89553 14.9163 2 12.7543 2 10.5C2 8.24566 2.89553 6.08365 4.48959 4.48959C6.08365 2.89553 8.24566 2 10.5 2C12.7543 2 14.9163 2.89553 16.5104 4.48959C18.1045 6.08365 19 8.24566 19 10.5V10.5Z' stroke='#A7A7A7' strokeWidth={2} strokeLinecap='round' />
                                            </svg>
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='r-news-list'>
                    <div className='container'>
                        {rows.length > 0 ? (
                            rows.map((item, index) => {
                                return (
                                    <div className='news-item'>
                                        <div className='row'>
                                            <div className='col-12 col-md-5'>
                                                <Link href={`/blog/${item.seo_url}`} className='image d-block'>
                                                    <img src={item.image} style={{ maxHeight: 263, borderRadius: 15, width: 445, maxWidth: "100%", height: '100%', objectFit: 'cover', cursor: 'pointer' }} alt='' />
                                                </Link>
                                            </div>
                                            <div className='col-12 col-md-7'>
                                                <div className='content'>
                                                    <a onClick={() => getPostByCategory(item?.postcategory?.name)} className='category'>{item?.postcategory?.name}</a>
                                                    <Link href={`/${props.sign}/blog/${item.seo_url}`}><a className='title'>{item?.title}</a></Link>
                                                    <div className='date'>{moment(item?.show_date || item?.createdAt).format('YYYY/MM/DD')}</div>
                                                    <p className='content-news'>{item?.html_content}</p>
                                                    <ul className='tag'>
                                                        {item.tag ? (
                                                            item.tag.map((tag, index) => {
                                                                return (
                                                                    <li key={index}>
                                                                        <a onClick={() => filterTag(tag.tag.name)}>{tag.tag.name}</a>
                                                                    </li>
                                                                );
                                                            })
                                                        ) : null}
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        ) : <div id='not-found'>
                            <div className='main-content'>
                                <div className='container'>
                                    <div className='inner'>
                                        <div className='image'>
                                            <img src='/assets/images/404-search.png' alt='' />
                                        </div>
                                        <h3>{trans.project.no_result}</h3>
                                        <a href='/' className='btn-back'>{trans.project.back_home}</a>
                                    </div>
                                </div>
                            </div>
                        </div>}

                        {rows.length < total ? <div className='text-center'>
                            <a onClick={() => loadMore()} className='see-more'>
                                続きを見る
                                <svg width={78} height={39} viewBox='0 0 78 39' fill='none' xmlns='http://www.w3.org/2000/svg'>
                                    <path fillRule='evenodd' clipRule='evenodd' d='M77.1601 20.821C77.5415 20.4396 77.7557 19.9224 77.7557 19.3831C77.7557 18.8438 77.5415 18.3266 77.1601 17.9453L59.9062 0.691336C59.5248 0.310001 59.0076 0.0957691 58.4684 0.0957692C57.9291 0.0957693 57.4119 0.31 57.0305 0.691336C56.6492 1.07267 56.435 1.58988 56.435 2.12917C56.435 2.66846 56.6492 3.18566 57.0305 3.567L70.8136 17.35L2.28132 17.3472C2.01395 17.3472 1.7492 17.3998 1.50218 17.5021C1.25517 17.6045 1.03072 17.7544 0.841666 17.9435C0.652608 18.1325 0.50264 18.357 0.400324 18.604C0.298006 18.851 0.245348 19.1158 0.245346 19.3831C0.245347 19.6505 0.298007 19.9153 0.400323 20.1623C0.502642 20.4093 0.652613 20.6337 0.84167 20.8228C1.03073 21.0118 1.25517 21.1618 1.50218 21.2641C1.7492 21.3664 2.01395 21.4191 2.28131 21.4191L70.8136 21.4162L57.0305 35.1993C56.6492 35.5806 56.4349 36.0978 56.4349 36.6371C56.4349 37.1764 56.6492 37.6936 57.0305 38.0749C57.4119 38.4563 57.9291 38.6705 58.4684 38.6705C59.0076 38.6705 59.5248 38.4563 59.9062 38.0749L77.1601 20.821Z' fill='#FDFDFD' />
                                </svg>
                            </a>
                        </div> : null}
                    </div>
                </div>
            </div>
        </>
    );
}